module.exports = {"id":"dp4_4l3q4","text":"Environmental Impacts of Digital Technologies","instructions":"How often do you consider environmental impact when purchasing digital devices?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.4","questionType":"Scale","random":false,"options":[{"id":"dp4_4l3q4-a1","text":"Never","score":2},{"id":"dp4_4l3q4-a2","text":"Rarely","score":2.4},{"id":"dp4_4l3q4-a3","text":"Sometimes","score":3},{"id":"dp4_4l3q4-a4","text":"Often","score":3.6},{"id":"dp4_4l3q4-a5","text":"Always","score":4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.4/l3q4.json
// module id = 1274
// module chunks = 41